import styles from './MemoryCoreWidget.module.css';

const MemoryCoreWidget = () => {
  return (
    <div className={styles.widgetContainer}>
      <div className={styles.svgContainer}>
        <svg viewBox="0 0 400 200" className={styles.neuralNetwork}>
          {/* Connections */}
          <line
            x1="50"
            y1="100"
            x2="200"
            y2="50"
            className={styles.connection}
          />
          <line
            x1="50"
            y1="100"
            x2="200"
            y2="150"
            className={styles.connection}
          />
          <line
            x1="200"
            y1="50"
            x2="350"
            y2="100"
            className={styles.connection}
          />
          <line
            x1="200"
            y1="150"
            x2="350"
            y2="100"
            className={styles.connection}
          />
          <line
            x1="200"
            y1="50"
            x2="200"
            y2="150"
            className={styles.connectionAlt}
          />

          {/* Nodes (Synapses) */}
          <circle cx="50" cy="100" r="15" className={styles.node} />
          <circle cx="200" cy="50" r="20" className={styles.node} />
          <circle cx="200" cy="150" r="12" className={styles.node} />
          <circle cx="350" cy="100" r="25" className={styles.nodeCore} />
        </svg>
      </div>
      <div className={styles.overlay}>
        <h4>The Memory Core is Coming Soon</h4>
        <p>
          Build a unique neural network of your AI's memories to make your
          Digital Passport even more authentic and powerful.
        </p>
      </div>
    </div>
  );
};

export default MemoryCoreWidget;
